import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';

import { UBXDatepickerComponent } from './datepicker.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
];

const Module = [
    UBXDatepickerComponent
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXDatepickerModule {}
